import { BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("babiSolde_api");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = null;
    }

    return config;
  },
  function (error) {
    console.log("AN ERROR REQUEST", error);
  }
);

export const ListDesAdmims = async (page, size, param) => {
  return await axios.get(
    `${BASE_URL}/auth/allAdmins?page=${page}&size=${size}&param=${param}`,
    {}
  );
};

export const recupererListeCompletClient = async (page, limit, search) => {
  return await axios.get(
    `${BASE_URL}/visiteurs/all?page=${page}&limit=${limit}&search=${search}`,
    {}
  );
};

export const telechargerClientCsv = async (page, limit, search) => {
  return axios.get(
    `${BASE_URL}/visiteurs/all?page=${page}&limit=${limit}&search=${search}`,
    {
      params: { export: "csv" },
      responseType: "blob" // ← très important
    }
  );
};

// router.delete("/supprimer/:id", visiteurControlles.deleteVisiteur);

export const supprminerClient = async (idAdmin) => {
  return await axios.delete(`${BASE_URL}/visiteurs/supprimer/${idAdmin}`, {});
};

// export const desactivUserById = async (idAdmin) => {
//   return await axios.put(BASE_URL(`utilisateur/desactive/${idAdmin}`), {});
// };

export const udpdateAdnim = async (idAdmin, data) => {
  return await axios.put(`${BASE_URL}/auth/${idAdmin}`, data);
};
